module.exports = __webpack_public_path__ + "static/media/goodnest_app1.cc541bf1.jpg";